





















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ContactLensItemDetailStore from '../store'

import ContactLensPowerLeftDropdown from '@ajax/vue/components/organisms/contact-lens/power/LeftDropdown.vue'

@Component({
  components: {
    ContactLensPowerLeftDropdown,
  },
})
export default class ContactLensPowerLeftArea extends Vue {
  @Prop({ required: true })
  id: string

  @Prop({ required: true })
  store: ContactLensItemDetailStore | null

  @Prop({ required: true })
  isLoading: boolean
}
